var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "white py-0 pb-5", attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            {
              staticClass:
                "modal-title white--text d-flex justify-space-between align-center",
              staticStyle: { position: "sticky", "z-index": "15", top: "0" },
              attrs: { cols: "12" }
            },
            [
              _c(
                "h3",
                { staticClass: "d-flex align-center font-weight-regular" },
                [
                  _c("v-icon", { attrs: { dark: "" } }, [_vm._v("mdi-server")]),
                  _vm._v(" " + _vm._s(_vm.titleForm) + " ")
                ],
                1
              ),
              _c(
                "v-icon",
                {
                  attrs: { dark: "" },
                  on: {
                    click: function() {
                      return _vm.closeDialog(false)
                    }
                  }
                },
                [_vm._v("mdi-close")]
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "v-stepper",
                {
                  staticClass: "elevation-0 mb-n5 px-2",
                  model: {
                    value: _vm.currentStep,
                    callback: function($$v) {
                      _vm.currentStep = $$v
                    },
                    expression: "currentStep"
                  }
                },
                [
                  _c(
                    "v-stepper-header",
                    { staticClass: "elevation-0" },
                    [
                      [
                        _c(
                          "v-avatar",
                          {
                            staticClass:
                              "d-flex align-self-center justify-self-center justify-center ;",
                            staticStyle: { "z-index": "2" },
                            attrs: {
                              color:
                                1 == _vm.currentStep
                                  ? "rgb(25, 58, 81)"
                                  : "white",
                              size: 1 == _vm.currentStep ? 64 : 50
                            }
                          },
                          [
                            _c("v-stepper-step", {
                              class:
                                this.$vuetify.breakpoint.width > 960
                                  ? "ml-4"
                                  : "",
                              staticStyle: {
                                transform: "scale(2)",
                                "z-index": "2",
                                opacity: "1"
                              },
                              attrs: {
                                complete: _vm.currentStep > 1,
                                step: 1,
                                color: "#94CA4E"
                              }
                            })
                          ],
                          1
                        ),
                        1 !== _vm.steps
                          ? _c("v-progress-linear", {
                              key: 1,
                              staticClass:
                                "d-flex align-self-center px-12 mr-12",
                              staticStyle: {
                                position: "absolute",
                                display: "inline",
                                "z-index": "1"
                              },
                              attrs: { color: "primaryGreen", value: "100" }
                            })
                          : _vm._e()
                      ],
                      [
                        _c(
                          "v-avatar",
                          {
                            staticClass:
                              "d-flex align-self-center justify-self-center justify-center ;",
                            staticStyle: { "z-index": "2" },
                            attrs: {
                              color:
                                2 == _vm.currentStep
                                  ? "rgb(25, 58, 81)"
                                  : "white",
                              size: 2 == _vm.currentStep ? 64 : 50
                            }
                          },
                          [
                            _c("v-stepper-step", {
                              class:
                                this.$vuetify.breakpoint.width > 960
                                  ? "ml-4"
                                  : "",
                              staticStyle: {
                                transform: "scale(2)",
                                "z-index": "2",
                                opacity: "1"
                              },
                              attrs: {
                                complete: _vm.currentStep > 2,
                                step: 2,
                                color: "#94CA4E"
                              }
                            })
                          ],
                          1
                        ),
                        2 !== _vm.steps
                          ? _c("v-progress-linear", {
                              staticClass:
                                "d-flex align-self-center px-12 mr-12",
                              staticStyle: {
                                position: "absolute",
                                display: "inline",
                                "z-index": "1"
                              },
                              attrs: { color: "primaryGreen", value: "100" }
                            })
                          : _vm._e()
                      ]
                    ],
                    2
                  ),
                  _c(
                    "v-stepper-items",
                    [
                      _c(
                        "v-stepper-content",
                        { attrs: { step: "1" } },
                        [
                          _c(
                            "v-container",
                            [
                              _c("h2", { staticClass: "text--black" }, [
                                _vm._v("Información de Equipo")
                              ]),
                              _c(
                                "v-form",
                                { ref: "form" },
                                [
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12", md: "6" } },
                                        [
                                          _c("br"),
                                          _c(
                                            "h3",
                                            { staticClass: "ml-2 text--black" },
                                            [_vm._v("Nombre de equipo")]
                                          ),
                                          _c("v-text-field", {
                                            attrs: {
                                              rules: _vm.rules.defaultRules,
                                              "validate-on-blur": "",
                                              label:
                                                "Introduzca el nombre del Equipo",
                                              "single-line": "",
                                              counter: "",
                                              maxlength: "100",
                                              required: ""
                                            },
                                            model: {
                                              value: _vm.equipment.name,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.equipment,
                                                  "name",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression: "equipment.name"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "mt-n7",
                                          attrs: { cols: "12", sm: "6" }
                                        },
                                        [
                                          _c("br"),
                                          _c(
                                            "h3",
                                            { staticClass: "ml-2 text--black" },
                                            [
                                              _vm._v(
                                                " Data Center e Instalación "
                                              )
                                            ]
                                          ),
                                          _c(
                                            "v-autocomplete",
                                            {
                                              attrs: {
                                                items:
                                                  _vm.buildingsDataCentersOptions,
                                                "auto-select-first": "",
                                                "item-value": "id",
                                                "item-text": "name",
                                                rules:
                                                  _vm.rules.defaultArrayRules,
                                                "no-data-text":
                                                  "No se encontraron resultados",
                                                color: "blue-grey lighten-2",
                                                label:
                                                  "Selecciona un data center",
                                                "single-line": "",
                                                clearable: "",
                                                required: "",
                                                chips: "",
                                                multiple: ""
                                              },
                                              scopedSlots: _vm._u([
                                                {
                                                  key: "selection",
                                                  fn: function(data) {
                                                    return [
                                                      _c(
                                                        "v-chip",
                                                        _vm._b(
                                                          {
                                                            attrs: {
                                                              "input-value":
                                                                data.selected,
                                                              close: ""
                                                            },
                                                            on: {
                                                              click:
                                                                data.select,
                                                              "click:close": function(
                                                                $event
                                                              ) {
                                                                return _vm.removeBuildingsDataCentersSelected(
                                                                  data.item
                                                                )
                                                              }
                                                            }
                                                          },
                                                          "v-chip",
                                                          data.attrs,
                                                          false
                                                        ),
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                data.item.name
                                                              ) +
                                                              " "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  }
                                                },
                                                {
                                                  key: "item",
                                                  fn: function(data) {
                                                    return [
                                                      _c(
                                                        "v-list-item-content",
                                                        [
                                                          _c(
                                                            "v-list-item-title",
                                                            {
                                                              domProps: {
                                                                innerHTML: _vm._s(
                                                                  data.item.name
                                                                )
                                                              }
                                                            }
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  }
                                                }
                                              ]),
                                              model: {
                                                value:
                                                  _vm.equipment
                                                    .buildingsDataCentersSelected,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.equipment,
                                                    "buildingsDataCentersSelected",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "equipment.buildingsDataCentersSelected"
                                              }
                                            },
                                            [
                                              _c(
                                                "template",
                                                { slot: "prepend-inner" },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      staticClass: "mr-3",
                                                      attrs: { color: "green" }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "mdi-clipboard-text"
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            2
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "mt-n7",
                                          attrs: { cols: "12", sm: "6" }
                                        },
                                        [
                                          _c("br"),
                                          _c(
                                            "h3",
                                            { staticClass: "ml-2 text--black" },
                                            [_vm._v("Parámetros")]
                                          ),
                                          _c(
                                            "v-autocomplete",
                                            {
                                              attrs: {
                                                items: _vm.parameters,
                                                "auto-select-first": "",
                                                "item-value": "id",
                                                "item-text": "fullName",
                                                rules:
                                                  _vm.rules.defaultArrayRules,
                                                "no-data-text":
                                                  "No se encontraron resultados",
                                                color: "blue-grey lighten-2",
                                                label:
                                                  "Selecciona un parámetro",
                                                "single-line": "",
                                                clearable: "",
                                                chips: "",
                                                required: "",
                                                multiple: "",
                                                loading: _vm.isFetchingData
                                              },
                                              scopedSlots: _vm._u([
                                                {
                                                  key: "selection",
                                                  fn: function(data) {
                                                    return [
                                                      _c(
                                                        "v-chip",
                                                        _vm._b(
                                                          {
                                                            attrs: {
                                                              "input-value":
                                                                data.selected,
                                                              close: ""
                                                            },
                                                            on: {
                                                              click:
                                                                data.select,
                                                              "click:close": function(
                                                                $event
                                                              ) {
                                                                return _vm.removeParametersSelected(
                                                                  data.item
                                                                )
                                                              }
                                                            }
                                                          },
                                                          "v-chip",
                                                          data.attrs,
                                                          false
                                                        ),
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                data.item
                                                                  .fullName
                                                              ) +
                                                              " "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  }
                                                },
                                                {
                                                  key: "item",
                                                  fn: function(data) {
                                                    return [
                                                      _c(
                                                        "v-list-item-content",
                                                        [
                                                          _c(
                                                            "v-list-item-title",
                                                            {
                                                              domProps: {
                                                                innerHTML: _vm._s(
                                                                  data.item
                                                                    .fullName
                                                                )
                                                              }
                                                            }
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  }
                                                }
                                              ]),
                                              model: {
                                                value:
                                                  _vm.equipment
                                                    .parametersSelected,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.equipment,
                                                    "parametersSelected",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "equipment.parametersSelected"
                                              }
                                            },
                                            [
                                              _c(
                                                "template",
                                                { slot: "prepend-inner" },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      staticClass: "mr-3",
                                                      attrs: { color: "green" }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "mdi-clipboard-text"
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            2
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-stepper-content",
                        { attrs: { step: "2" } },
                        [
                          _c(
                            "v-container",
                            [
                              _c(
                                "v-row",
                                {
                                  class:
                                    this.$vuetify.breakpoint.name === "sm"
                                      ? "mx-n11"
                                      : ""
                                },
                                [
                                  _c(
                                    "v-col",
                                    { staticClass: "d-flex justify-center" },
                                    [
                                      !_vm.equipmentTransaction
                                        ? _c(
                                            "h2",
                                            { staticClass: "text--black" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.equipment.name) +
                                                  " "
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                ],
                                1
                              ),
                              !_vm.equipmentTransaction
                                ? _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "mt-0",
                                          attrs: { cols: "12" }
                                        },
                                        [
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass:
                                                    "d-flex justify-center",
                                                  attrs: { cols: "12" }
                                                },
                                                [
                                                  _c("img", {
                                                    staticClass: "mr-2",
                                                    attrs: {
                                                      src: require("@/assets/IconE.svg"),
                                                      width: "100px",
                                                      height: "100px"
                                                    }
                                                  })
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _c("v-divider"),
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass:
                                                    "d-flex justify-center mt-4",
                                                  attrs: { cols: "12" }
                                                },
                                                [
                                                  _c("h3", [
                                                    _vm._v(
                                                      "Data Centers e Instalaciones"
                                                    )
                                                  ])
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            _vm._l(
                                              _vm.selectedBuildingsDataCentersToDisplay(),
                                              function(
                                                buildingsDataCenter,
                                                index
                                              ) {
                                                return _c(
                                                  "v-col",
                                                  {
                                                    key: "BDC" + index,
                                                    class:
                                                      _vm.selectedBuildingsDataCentersToDisplay()
                                                        .length < 4
                                                        ? "d-flex justify-center"
                                                        : "d-flex justify-row",
                                                    attrs: {
                                                      cols: _vm.columnLayout(
                                                        _vm.selectedBuildingsDataCentersToDisplay()
                                                          .length
                                                      )
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        attrs: { color: "blue" }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "mdi-city-variant"
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(
                                                      _vm._s(
                                                        buildingsDataCenter.name
                                                      ) + " "
                                                    )
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            1
                                          ),
                                          _c("v-divider"),
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass:
                                                    "d-flex justify-center mt-4",
                                                  attrs: { cols: "12" }
                                                },
                                                [
                                                  _c("h3", [
                                                    _vm._v("Parámetros")
                                                  ])
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            _vm._l(
                                              _vm.selectedParametersToDisplay(),
                                              function(parameter, index) {
                                                return _c(
                                                  "v-col",
                                                  {
                                                    key: "P" + index,
                                                    class:
                                                      _vm.selectedParametersToDisplay()
                                                        .length === 2 &&
                                                      index === 0
                                                        ? "d-flex flex-row-reverse "
                                                        : _vm.selectedParametersToDisplay()
                                                            .length === 2 &&
                                                          index === 1
                                                        ? "d-flex flex-row"
                                                        : "d-flex justify-center",
                                                    attrs: {
                                                      cols: _vm.columnLayout(
                                                        _vm.selectedParametersToDisplay()
                                                          .length
                                                      )
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "v-card",
                                                      {
                                                        staticClass: "mx-2",
                                                        staticStyle: {
                                                          background:
                                                            "linear-gradient(",
                                                          "border-radius":
                                                            "10% !important"
                                                        },
                                                        attrs: {
                                                          width: "175",
                                                          dark: ""
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "v-row",
                                                          {
                                                            staticStyle: {
                                                              "border-radius":
                                                                "10% !important"
                                                            },
                                                            attrs: {
                                                              justify: "center"
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "v-col",
                                                              {
                                                                staticClass:
                                                                  "d-flex justify-center overline mx-n3",
                                                                staticStyle: {
                                                                  "text-align":
                                                                    "center",
                                                                  "font-size":
                                                                    "15px !important"
                                                                },
                                                                attrs: {
                                                                  cols: "12"
                                                                }
                                                              },
                                                              [
                                                                _c("b", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      parameter.name
                                                                    ) + " "
                                                                  )
                                                                ])
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-row",
                                                          {
                                                            staticClass:
                                                              "mt-n3 mb-n3 d-flex justify-center",
                                                            attrs: {
                                                              justify: "center"
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "v-col",
                                                              {
                                                                staticClass:
                                                                  "d-flex justify-center mt-0",
                                                                staticStyle: {
                                                                  "text-align":
                                                                    "center",
                                                                  "font-size":
                                                                    "50px"
                                                                },
                                                                attrs: {
                                                                  cols: "12"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      parameter.measureUnit
                                                                    ) +
                                                                    " "
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : !_vm.equipmentTransactionFinished
                                ? _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass:
                                            "d-flex justify-center align-center",
                                          attrs: { cols: "12" }
                                        },
                                        [
                                          _c(
                                            "v-progress-circular",
                                            {
                                              attrs: {
                                                size: 200,
                                                width: 7,
                                                color: "success",
                                                indeterminate: ""
                                              }
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    color: "green",
                                                    size: 50
                                                  }
                                                },
                                                [_vm._v("mdi-server")]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c("v-col", { attrs: { cols: "12" } }, [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "d-flex justify-center align-center display-1",
                                            staticStyle: {
                                              "text-align": "center"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.loadingText) +
                                                " "
                                            )
                                          ]
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          !_vm.equipmentTransaction && !_vm.equipmentTransactionFinished
            ? _c(
                "v-col",
                {
                  staticClass: "d-flex justify-end align-center",
                  attrs: { cols: "12" }
                },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "mr-2",
                      attrs: { color: "green", outlined: "" },
                      on: {
                        click: function() {
                          return _vm.closeDialog(false)
                        }
                      }
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.currentStep !== 1,
                          expression: "currentStep !== 1"
                        }
                      ],
                      staticClass: "white--text mr-2",
                      attrs: { color: "green" },
                      on: {
                        click: function($event) {
                          return _vm.previousStep(_vm.currentStep)
                        }
                      }
                    },
                    [
                      _c("v-icon", [_vm._v("mdi-chevron-left")]),
                      _vm._v("Anterior ")
                    ],
                    1
                  ),
                  _vm.currentStep !== 2
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "white--text mr-2",
                          attrs: { color: "green" },
                          on: {
                            click: function($event) {
                              return _vm.nextStep(_vm.currentStep)
                            }
                          }
                        },
                        [
                          _vm._v(" Siguiente "),
                          _c("v-icon", [_vm._v("mdi-chevron-right")])
                        ],
                        1
                      )
                    : _c(
                        "v-btn",
                        {
                          staticClass: "white--text mr-2",
                          attrs: {
                            color: "green",
                            disabled: _vm.currentStep !== 2
                          },
                          on: {
                            click: function($event) {
                              return _vm.submitEquipment()
                            }
                          }
                        },
                        [
                          _vm._v(" Guardar "),
                          _c("v-icon", { staticClass: "ml-1" }, [
                            _vm._v("mdi-check-all")
                          ])
                        ],
                        1
                      )
                ],
                1
              )
            : _vm._e(),
          _c(
            "v-snackbar",
            {
              attrs: {
                top: "",
                absolute: "",
                timeout: 15000,
                color: _vm.snackbarColor
              },
              model: {
                value: _vm.snackbar,
                callback: function($$v) {
                  _vm.snackbar = $$v
                },
                expression: "snackbar"
              }
            },
            [
              _vm._v(" " + _vm._s(_vm.snackbarText) + " "),
              _c(
                "v-btn",
                {
                  attrs: { color: "white", text: "" },
                  on: { click: _vm.closeSnackbar }
                },
                [_vm._v(" Cerrar ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }